/**
 * 侧边导航栏组件
 */
// eslint-disable-next-line no-use-before-define
import React, { Key, useEffect } from 'react';
import { connect } from 'react-redux';
import routerConfig from 'src/router/menuRouter';
import { RouterConfig } from 'src/router/types';
import { Menu, Layout, Space, Typography } from 'antd';
import CustomIcon, { IconName } from 'src/components/common/icon/customIcon';
import { LangMessage } from 'src/store/common/language';
import { MENUTABS_ADD } from 'src/store/common/menuTabs';
import { MenuTree } from 'src/api/homePage/type';
import useFetchState from 'src/utils/useFetchState';
import { useHistory } from 'react-router-dom';
import { deepClone, findActiveRoute } from 'src/utils/utils';
import { COLLAPSED_TOGGLE } from 'src/store/common/collapsed';
import collapsedIcon from 'src/assets/imgs/common/collapsed-icon.png';
import { useThrottle } from 'src/utils/utils';
import timeZoneIcon from 'src/assets/imgs/common/timezone-icon.png';
import timeIcon from 'src/assets/imgs/common/time-icon.png';
import { SelectInfo } from 'rc-menu/es/interface';
const { Sider } = Layout;
const { SubMenu } = Menu;
const { Text } = Typography;

const MenuDom = (menuList: RouterConfig[], Mes: LangMessage, addTabs: Function) =>
    <>
        {menuList.map((v: RouterConfig) => {
            if (v.subs && v.subs.length) {
                return (
                    <SubMenu key={v.key} title={<span title={Mes[v.title]}>{ Mes[v.title]}</span>} icon={v.icon && <CustomIcon IconName={v.icon as IconName} />}>
                        {MenuDom(v.subs, Mes, addTabs)}
                    </SubMenu>
                );
            }
            if (!v.isNoSub) {
                return (
                    <Menu.Item key={v.key} icon={v.icon && <CustomIcon IconName={v.icon as IconName} />}>
                        <a
                            title={ Mes[v.title] }
                            onClick={() => {
                                addTabs(v);
                            }}>
                            {Mes[v.title]}
                        </a>
                    </Menu.Item>
                );
            }
        })}
    </>;


// 菜单权限验证
// eslint-disable-next-line no-unused-vars
const verifyMenuPermission = (localMenu: RouterConfig[], roleMenu: MenuTree[]) => localMenu.filter((v: RouterConfig) => {
    if (v.key === 'others' || v.key === 'langManage' || v.requireAuth || v.key === 'Home') {return v;}
    const item = roleMenu.find((o: MenuTree) => {
        if (o.menuKey === v.key) {
            return v;
        }
    });

    if (item) {
        if (v.subs && v.subs.length && item.children && item.children.length) {
            v.subs = verifyMenuPermission(v.subs, item.children);
        }
        return v;
    }
});

interface Props {
    Mes: LangMessage;
    menuList:MenuTree[];
    dispatch: any;
    curMenu: string;
    collapsed: boolean;
    serverTime: string;
    timeZone: string;
}

const MenuNav = (props: Props) => {
    const { Mes, dispatch, menuList = [], curMenu, collapsed, serverTime } = props;
    const history = useHistory();

    let menus: RouterConfig[] = [];
    const cloneRouter = deepClone(routerConfig);

    Object.keys(cloneRouter).map((key: string) => {
        menus = menus.concat(cloneRouter[key]);
    });
    const menuRouter = verifyMenuPermission(menus, menuList);

    const rootSubmenuKeys = menus.map((v: RouterConfig) => v.key);

    const [ openKeys, setOpenKeys ] = useFetchState<string[]>([]);
    const [ selectedKeys, setSelectedKeys ] = useFetchState<string[]>([]);

    const onOpenChange = (keys: Key[]) => {
        const menuKeys: string[] = [];

        keys.forEach((v: Key) => typeof v === 'string' && menuKeys.push(v));
        const latestOpenKey: string = menuKeys.find((key: string) => openKeys.indexOf(key) === -1) || '';

        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(menuKeys);
        } else {
            setOpenKeys(latestOpenKey ? [ latestOpenKey ] : []);
        }
    };
    const menuChange = (info: SelectInfo) => {
        setSelectedKeys(info.selectedKeys);
    };

    const collapsChange = useThrottle(() => {
        dispatch({
            type: COLLAPSED_TOGGLE,
            value: !collapsed,
        });
    }, 600);

    const addTabs = (v: RouterConfig) => {
        dispatch({
            type: MENUTABS_ADD,
            value: {
                key: v.key,
                title: v.title,
                route: v.route,
            },
        });
        history.push(v.route, {
            tabsTatus: true,
        });
    };

    useEffect(() => {
        const selKeys: string[] = [];

        findActiveRoute(curMenu, menuRouter, selKeys);
        if (!collapsed) {
            setOpenKeys([ selKeys?.[0] ]);
        }
        setSelectedKeys(selKeys);
    }, [ curMenu ]);

    return (
        <Sider
            collapsed={collapsed}
            id='menuNav'
            collapsedWidth={68}
            theme='light'
            trigger={null}
            width={270}
        >
            <Space className={!collapsed ? 'menu-logo-unfold' : 'menu-logo-shrink' } direction={!collapsed ? 'horizontal' : 'vertical'}>
                <CustomIcon IconName={!collapsed ? 'CFELogo' : 'CFE'} />
            </Space>
            <img src={collapsedIcon} className={`menu-collapsed ${collapsed ? 'unfold' : ''}`} onClick={collapsChange} />
            <Menu mode='inline'
                openKeys={openKeys}
                selectedKeys={selectedKeys}
                onSelect={menuChange}
                onOpenChange={onOpenChange}>
                {MenuDom(menuRouter, Mes, addTabs)}
            </Menu>
            {
                !collapsed ? (
                    <Space direction='vertical' className={`menu-time ${!collapsed ? 'show' : 'hide'}`} align='start'>
                        <Space>
                            <img src={timeZoneIcon} />
                            <Text>{ Mes['labelTextTimeZoneAmerica'] }</Text>
                        </Space>
                        <Space>
                            <img src={timeIcon} />
                            <Text>{ serverTime }</Text>
                        </Space>
                    </Space>
                ) : (
                    <Space className='menu-time-icon' align='center'>
                        <img src={timeIcon} title={`${Mes['labelTextTimeZoneAmerica']} ${serverTime}`} />
                    </Space>
                )
            }
        </Sider>
    );
};

export default connect((state: any) => ({
    Mes: state.langSwitch.message,
    menuList: state.userInfo.menuList,
    curMenu: state.activeMenus.curMenu,
    collapsed: state.toggleCollapsed.collapsed,
    serverTime: state.defaultTime.serverTime,
    timeZone: state.defaultTime.timeZone,
}))(MenuNav);
